import { TrackingContext } from '@ps/web-core-analytics';
import { merge } from 'lodash';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';

import styles from './SportsBetSlipWidget.scss';
import BetReceipt from './components/BetReceipt/BetReceipt';
import BetSlip from './components/BetSlip/BetSlip';
import usePersistBetslip from './hooks/usePersistBetSlip';

const SportsBetSlipWidget: WidgetFC = () => {
  const receipt = useSelector(select.betSlip.receipt);
  const trackingContextValue = useContext(TrackingContext);
  usePersistBetslip();

  return receipt.SINGLE.length || receipt.MULTIPLE.length ? (
    <BetReceipt />
  ) : (
    <TrackingContext.Provider
      value={merge(trackingContextValue, { widget: { widgetContext: 'BET_SLIP' } })}
    >
      <BetSlip />
    </TrackingContext.Provider>
  );
};

export default withWidgetTestId(
  SportsBetSlipWidget,
  'sports-bet-slip',
  {
    className: styles.widget
  },
  'div',
  'sports'
);
